import { Modal } from '@components/ui';
import { useRouter } from 'next/router';
import React from 'react';

interface ExitModalProps {
  showExitModal: boolean;
  redirectUrl: string;
  explicitelyLeavePage: React.MutableRefObject<boolean>;
  onClose: () => void;
}

export const ExitConfirmModal: React.FC<ExitModalProps> = ({
  showExitModal,
  redirectUrl,
  onClose,
  explicitelyLeavePage,
}) => {
  const { back, push } = useRouter();

  return (
    <Modal
      view="confirm"
      showModal={showExitModal}
      data={{
        title: 'Caution: Your questionnaire data hasn’t been saved',
        text: 'If you exit the questionnaire page now, all changes you just made will be lost.',
        cancelButton: { text: 'continue editing', onClick: onClose },
        confirmButton: {
          text: 'exit now',
          onClick: () => {
            explicitelyLeavePage.current = true; // eslint-disable-line
            onClose();
            if (redirectUrl) {
              push(`${redirectUrl}`);
            } else {
              back();
            }
          },
        },
      }}
      onClose={onClose}
    />
  );
};
